import { render } from "./RoomCategoryForm.vue?vue&type=template&id=131755d3"
import script from "./RoomCategoryForm.vue?vue&type=script&lang=js"
export * from "./RoomCategoryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__